/**
 * @file variantsFind.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Sep 25, 2023 20:22
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import {
    VARIANT_SEARCH_REQUEST,
    variantSearchSuccess,
    variantSearchFailure,
} from 'src/store/actions/variant/variantDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/variant/variants/find';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            searchMethod: payload.searchMethod,
            searchTerm: payload.searchTerm,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* searchRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);
        yield put(variantSearchSuccess(resp.payload));

    } catch (error) {
        yield put(variantSearchFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* searchRequestMonitor() {
    yield takeLatest(VARIANT_SEARCH_REQUEST, searchRequestSaga);
}
